import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocationService } from '../services/location.service';

@Pipe({
	name: 'locationName',
})
export class LocationNamePipe implements PipeTransform {
	constructor(private locationService: LocationService) {}

	async transform(value: unknown, ...args: unknown[]): Promise<string | null> {
		if (typeof value === 'string' && value) {
			return await this.locationService.getNameByUuid$(value);
		}

		return null;
	}
}
